import React from "react";

/**
 * A single labeled form field. Supports text/number/date/time inputs,
 * select dropdowns, textareas, and radio groups.
 */
export default function FormField({
  label,
  name,
  type = "text",
  value,
  onChange,
  options,
  placeholder,
  required = false,
  unit,
  full = false,
  rows = 3,
}) {
  const baseInputClasses =
    "w-full rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm text-navy placeholder:text-gray-400 outline-none transition focus:border-sky focus:ring-2 focus:ring-sky-light/50";

  return (
    <div className={full ? "sm:col-span-2" : ""}>
      <label
        htmlFor={name}
        className="mb-1.5 block text-sm font-medium text-navy-light"
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>

      {type === "select" && (
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          className={baseInputClasses + " appearance-none"}
        >
          <option value="" disabled>
            انتخاب کنید...
          </option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      )}

      {type === "radio" && (
        <div className="flex flex-wrap gap-3">
          {options.map((opt) => (
            <label
              key={opt.value}
              className={`flex-1 cursor-pointer rounded-xl border px-4 py-2.5 text-center text-sm font-medium transition ${
                value === opt.value
                  ? "border-sky bg-sky/10 text-sky-dark"
                  : "border-gray-200 bg-white text-gray-500 hover:border-sky-light"
              }`}
            >
              <input
                type="radio"
                name={name}
                value={opt.value}
                checked={value === opt.value}
                onChange={onChange}
                className="sr-only"
              />
              {opt.label}
            </label>
          ))}
        </div>
      )}

      {type === "textarea" && (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          rows={rows}
          className={baseInputClasses + " resize-none"}
        />
      )}

      {!["select", "radio", "textarea"].includes(type) && (
        <div className="relative">
          <input
            id={name}
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            inputMode={type === "number" ? "numeric" : undefined}
            className={baseInputClasses + (unit ? " pl-14" : "")}
          />
          {unit && (
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-gray-400">
              {unit}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
